import type { ReactElement } from "react";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import SignalNameRich from "app/pages/sales-intelligence/sub-modules/signals/components/shared/Signal/SignalNameRich";

import type SignalFilters from "../../../models/core/SignalFilters";
import type UISignal from "../../../models/view/UISignal";
import { StyledSignalDescription } from "../styles";

import { StyledBottomRow, StyledSignal, StyledSignalInner, StyledTopRow } from "./styles";

export type SignalViewProps = {
    children?: ReactElement;
    className?: string;
    isSelected?: boolean;
    isHighlighted?: boolean;
    uiSignal: Readonly<UISignal<SignalFilters>>;
    onClick?(uiSignal: Readonly<UISignal<SignalFilters>>): void;
};

const SignalView = (props: SignalViewProps) => {
    const { children, className, isSelected, isHighlighted, uiSignal, onClick } = props;

    const isClickable = typeof onClick === "function";

    function handleClick() {
        if (isClickable) {
            onClick(uiSignal);
        }
    }

    return (
        <StyledSignal
            className={className}
            data-automation="signal"
            data-automation-alias={uiSignal.template.alias}
            data-automation-type={uiSignal.signalType}
            data-automation-signal-id={uiSignal.id}
            isSelected={isSelected}
            isHighlighted={isHighlighted}
            onClick={handleClick}
        >
            <StyledSignalInner>
                <StyledTopRow>
                    <SignalNameRich uiSignal={uiSignal} />
                    {children}
                </StyledTopRow>
                <StyledBottomRow>
                    <I18n
                        data-automation="description-text"
                        element={StyledSignalDescription}
                        translatable={uiSignal.template.description}
                    />
                </StyledBottomRow>
            </StyledSignalInner>
        </StyledSignal>
    );
};

export default SignalView;
